import { Directive, Input } from '@angular/core'
import { TemplateRef, ViewContainerRef } from '@angular/core'

import { IAuthentication } from 'core/auth/i-authentication.service'
import { IAuthorization } from 'core/auth/i-authorization.service'

@Directive({ selector: '[ifNotAllowed]' })
export class IfNotAllowedDirective {
  private prevAllowed: boolean = null

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authetication: IAuthentication,
    private authorization: IAuthorization
  ) { }

  @Input() set ifNotAllowed(policy: any[]) {
    let allowed = this.authorization.allowed(this.authetication.currentUser, ...policy)
    if(allowed && (this.prevAllowed === null || !this.prevAllowed)) {
      this.prevAllowed = true
      this.viewContainer.clear()
    }
    else if(!allowed && (this.prevAllowed === null || this.prevAllowed)) {
      this.prevAllowed = false
      this.viewContainer.createEmbeddedView(this.templateRef)
    }
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/directives/if-not-allowed.directive.ts